// export const startIdleTracking = () => {
//   const updateActivity = () => {
//     localStorage.setItem("last_activity", Date.now());
//   };

//   ["mousemove", "keydown", "click", "scroll"].forEach(event => {
//     window.addEventListener(event, updateActivity);
//   });

//   updateActivity();
// };


export const startIdleTracking = () => {
  const updateActivity = (event) => {
    const now = Date.now();
    // console.log("User activity detected:", event?.type, "at", new Date(now).toLocaleTimeString());

    localStorage.setItem("last_activity", now);
  };

  ["mousemove", "keydown", "click", "scroll"].forEach(event => {
    window.addEventListener(event, updateActivity);
  });

  console.log("Idle tracking started");
  updateActivity({ type: "initial-load" });
};